<div class="sections">
    <div>
        <form [formGroup]="form">
            <ng-container formArrayName="owners">
                <ng-container *ngFor="let group of form.controls.owners.controls; let i = index" [formGroup]="group">
                    <div class="icon-button" (click)="removeOwner(i)" *ngIf="i > 0">
                        <app-icon width="28px" height="28px" class="se-icon-button" src="minus"></app-icon>
                        <p>Remove this person</p>
                    </div>
                    <div class="field multiple">
                        <div class="flex-fill">
                            <h4>First name</h4>
                            <mat-form-field appearance="outline" appFormFieldFilled>
                                <input matInput
                                       formControlName="firstName"
                                       autocomplete="off"
                                       name="avoidSearch"
                                       (focus)="activeExplanationChange('firstName', true)"
                                       (focusout)="activeExplanationChange('firstName', false)"
                                       enterkeyhint="next"
                                />
                                <mat-error *ngIf="formControlError(group, 'firstName') === 'required'">First name is required</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="flex-fill">
                            <h4>Last name</h4>
                            <mat-form-field appearance="outline" appFormFieldFilled>
                                <input matInput
                                       formControlName="lastName"
                                       autocomplete="off"
                                       name="avoidSearch"
                                       (focus)="activeExplanationChange('lastName', true)"
                                       (focusout)="activeExplanationChange('lastName', false)"
                                       enterkeyhint="next"
                                />
                                <mat-error *ngIf="formControlError(group, 'lastName') === 'required'">Last name is required</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="field multiple">
                        <div class="flex-fill">
                            <h4>Phone number</h4>
                            <mat-form-field appearance="outline" appFormFieldFilled>
                                <input matInput
                                       formControlName="phoneNumber"
                                       autocomplete="off"
                                       name="avoidSearch"
                                       (focus)="activeExplanationChange('phoneNumber', true)"
                                       (focusout)="activeExplanationChange('phoneNumber', false)"
                                       enterkeyhint="next"
                                       inputmode="tel"
                                       mask="(000) 000-0000"
                                />
                                <mat-error *ngIf="formControlError(group, 'phoneNumber') === 'required'">Phone number is required</mat-error>
                                <mat-error *ngIf="formControlError(group, 'phoneNumber') === 'invalid'">Invalid phone number</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="flex-fill">
                            <h4>Email</h4>
                            <mat-form-field appearance="outline" appFormFieldFilled [class.mat-form-field-disabled]="i === 0"
                                matTooltip="Must be your email on Slick Estimates" matTooltipPosition="above" [matTooltipShowDelay]="500"
                            >
                                <input matInput [readonly]='i === 0' #emailInput
                                       formControlName="email"
                                       autocomplete="off"
                                       name="avoidSearch"
                                       (focus)="i === 0 ? emailInput.blur() : activeExplanationChange('email', true)"
                                       (focusout)="activeExplanationChange('email', false)"
                                       enterkeyhint="next"
                                />
                                <mat-error *ngIf="formControlError(group, 'email') === 'required'">Email is required</mat-error>
                                <mat-error *ngIf="formControlError(group, 'email') === 'invalid'">Invalid email</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="field multiple">
                        <div class="flex-fill">
                            <h4>Title</h4>
                            <mat-form-field appearance="outline" appFormFieldFilled>
                                <input matInput
                                       formControlName="title"
                                       autocomplete="off"
                                       name="avoidSearch"
                                       (focus)="activeExplanationChange('title', true)"
                                       (focusout)="activeExplanationChange('title', false)"
                                       enterkeyhint="next"
                                />
                                <mat-error *ngIf="formControlError(group, 'title') === 'required'">Title is required</mat-error>
                            </mat-form-field>
                        </div>
                        <div style="width: 150px">
                            <h4>Ownership</h4>
                            <mat-form-field appearance="outline" appFormFieldFilled>
                                <input matInput
                                       formControlName="ownershipPercentage"
                                       autocomplete="off"
                                       name="avoidSearch"
                                       (focus)="activeExplanationChange('ownershipPercentage', true)"
                                       (focusout)="activeExplanationChange('ownershipPercentage', false)"
                                       enterkeyhint="next"
                                       mask="999"
                                       type="number"
                                       (input)="max(100, 'ownershipPercentage', group)"
                                />
                                <div matSuffix>%</div>
                                <mat-error *ngIf="formControlError(group, 'ownershipPercentage') === 'required'">Required</mat-error>
                                <mat-error *ngIf="formControlError(group, 'ownershipPercentage') === 'invalid'">Invalid</mat-error>
                                <mat-error *ngIf="formControlError(group, 'ownershipPercentage') === 'total'">Cannot exceed 100%</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="field multiple">
                        <div class="flex-fill">
                            <h4>Citizenship</h4>
                            <mat-form-field appearance="outline" appFormFieldFilled>
                                <input matInput
                                       formControlName="citizenship"
                                       autocomplete="off"
                                       name="avoidSearch"
                                       (focus)="activeExplanationChange('citizenship', true)"
                                       (focusout)="activeExplanationChange('citizenship', false)"
                                       enterkeyhint="next"
                                />
                                <mat-error *ngIf="formControlError(group, 'citizenship') === 'required'">Citizenship is required</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="flex-fill">
                            <h4>Birth date</h4>
                            <mat-form-field appearance="outline"
                                            class="date-input"
                                            appFormFieldFilled
                                            (click)="datePicker.open()"
                            >
                                <img class="img-calendar" matPrefix
                                     src="../../../assets/icons/calendar.svg"
                                     width="16" height="16">
                                <input #dateInput
                                       matInput [disabled]="true"
                                       formControlName="birthDate"
                                       placeholder="MM/DD/YYYY"
                                       inputmode="numeric"
                                       [matDatepicker]="datePicker"
                                       autocomplete="off"
                                       name="avoidSearch"
                                       enterkeyhint="next"
                                       (focus)="activeExplanationChange('birthDate', true)"
                                       (focusout)="activeExplanationChange('birthDate', false); fixDate('birthDate', group)"
                                       (input)="maskInput($event, group.controls['birthDate'], '00/00/0000')"
                                >
                                <mat-datepicker #datePicker
                                                [disabled]="false"
                                                (opened)="activeExplanationChange('birthDateDatePicker', true)"
                                                (closed)="activeExplanationChange('birthDateDatePicker', false)"
                                ></mat-datepicker>
                                <mat-error *ngIf="formControlError(group, 'birthDate') === 'required'">Birth date is required</mat-error>
                                <mat-error *ngIf="formControlError(group, 'birthDate') === 'matDatepickerParse'">Invalid date</mat-error>
                                <mat-error *ngIf="formControlError(group, 'birthDate') === 'future'">Choose a date in the past</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="field">
                        <h4>Social Security Number (SSN)</h4>
                        <mat-form-field appearance="outline" appFormFieldFilled>
                            <input matInput
                                   formControlName="ssn"
                                   autocomplete="off"
                                   name="avoidSearch"
                                   (focus)="activeExplanationChange('ssn', true)"
                                   (focusout)="fixDashedNumber('ssn', group); activeExplanationChange('ssn', false)"
                                   (keydown)="digitsAndDash($event)"
                                   (paste)="onDigitsAndDashPaste($event)"
                                   enterkeyhint="next"
                            />
                            <mat-error *ngIf="formControlError(group, 'ssn') === 'required'">SSN is required</mat-error>
                            <mat-error *ngIf="formControlError(group, 'ssn') === 'digitCount'">Must be exactly 9 digits</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="field multiple">
                        <div class="flex-fill">
                            <div class="d-flex justify-content-between align-items-center">
                                <h4>Address</h4>
                                <h4 class="simple-text-button" (click)="clearAddress(i)" *ngIf="form.controls.owners.controls[i].controls.address.value !== null">Clear</h4>
                            </div>
                            <address-form-field
                                    formControlName="address"
                                    placeholder="Enter at least 7 characters for autocomplete"
                                    [error]="addressError(group, 'address')"
                                    (onFocus)="activeExplanationChange('address', $event)"
                            ></address-form-field>
                        </div>
                        <div style="width: 150px">
                            <h4>Unit</h4>
                            <mat-form-field appearance="outline" appFormFieldFilled>
                                <input matInput
                                       formControlName="unit"
                                       autocomplete="off"
                                       name="avoidSearch"
                                       (focus)="activeExplanationChange('unit', true)"
                                       (focusout)="activeExplanationChange('unit', false)"
                                       enterkeyhint="next"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
            <div class="icon-button" *ngIf="form.controls.owners.controls.length < 4" (click)="addOwner.emit()">
                <app-icon width="28px" height="28px" class="se-icon-button" src="plus"></app-icon>
                <p>Add owner</p>
            </div>
            <div class="field">
                <h4>Guarantor</h4>
                <mat-form-field appearance="outline" appFormFieldFilled>
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="trigger-area" (click)="ownersAutocomplete.isOpen ? guarantorTrigger.closePanel() : guarantorTrigger.openPanel()"></div>
                            <input matInput #guarantorInput
                               formControlName="guarantor"
                               autocomplete="off"
                               name="avoidSearch"
                               [matAutocomplete]="ownersAutocomplete"
                               (focus)="guarantorInput.blur()"
                               #guarantorTrigger="matAutocompleteTrigger"
                               [anchorAutocompleteOnScroll]="guarantorTrigger"
                               enterkeyhint="next"
                               type="text"
                        />
                        <mat-icon matSuffix class="rotate" [class.do]="ownersAutocomplete.isOpen">expand_more</mat-icon>
                    </div>
                    <mat-autocomplete #ownersAutocomplete="matAutocomplete"
                                      (opened)="activeExplanationChange('guarantor', true)"
                                      (closed)="activeExplanationChange('guarantor', false)"
                    >
                        <mat-option *ngFor="let owner of owners; let i = index" [value]="i">
                            {{ owner }}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="formControlError(form, 'guarantor') === 'invalid'">Select the guarantor</mat-error>
                </mat-form-field>
            </div>
        </form>
        <div class="actions">
            <button mat-flat-button color="primary" (click)="nextClick.emit()">{{ (progress === 100) ? 'Finalize' : 'Next' }}</button>
        </div>
    </div>

    <div class="divider"></div>

    <div>
        <div class="info" #containerDiv>
            <div class="background" #backgroundDiv [ngStyle]="bgStyles"></div>

            <div class="field-explanation" #itemDiv [class.active]="activeIndex === i" *ngFor="let field of fieldExplanations; let i = index" [id]="'nuvei_app_' + field.id">
                <p>{{ field.title }}</p>
                <h4>{{ field.explanation }}</h4>
            </div>
        </div>
    </div>
</div>